import ReactCountryFlag from 'react-country-flag';

export default ReactCountryFlag;
